import { getEntity } from 'entman';

import schemas from 'schemas';


export function getAnnotation(state, id) {
  return getEntity(state, schemas.Annotation, id);
}
